import { Button } from "antd";
import React from "react";
import { ArrowUpIcon } from "../../assets/icons";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import SummaryCreationData from "./components/SummaryCreationData";
import UsageStatistics from "./components/UsageStatistics";
import AuthService from "../../base/services/authentication.service";
import { UserRolesEnum } from "../auth/userRoles.enum";

const AccountSummary = () => {
   const navigate = useNavigate();
   const isSuperAdmin = AuthService.isAuthorized([UserRolesEnum.SuperAdmin]);

   return (
      <>
         <div className="accountSummaryContainer d-flex flex-column">
            <div className="mainSection">
               <div className="d-flex flex-column" style={{ gap: "24px" }}>
                  <label className="labelStatusMain">Account summary</label>
                  {
                     isSuperAdmin &&
                     <div className="summary-main">
                        <label className="labelTitle">
                           You're reaching your package limit. Upgrade it to have more space and create
                           without limits.
                        </label>
                        <Button
                           icon={<img src={ArrowUpIcon} alt="" />}
                           className="upgrade"
                           onClick={() => navigate("/admin/payment-information")}
                        >
                           Upgrade package
                        </Button>
                     </div>
                  }
                  <SummaryCreationData />
                  {isSuperAdmin && <UsageStatistics />}
               </div>
            </div>
         </div>
      </>
   );
};

export default AccountSummary;
